<?xml version="1.0" encoding="UTF-8" standalone="no"?>
<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="2.5in" height="3.5in" viewBox="-120 -168 240 336" preserveAspectRatio="none" class="card" face="7S">
   <symbol id="S7" viewBox="-500 -500 1000 1000" preserveAspectRatio="xMinYMid">
      <path d="M-265 -320L-265 -460L265 -460C135 -200 -90 100 -90 460" stroke="black" stroke-width="80" stroke-linecap="square" stroke-miterlimit="1.5" fill="none"/>
   </symbol>
   <symbol id="S" viewBox="-600 -600 1200 1200" preserveAspectRatio="xMinYMid">
      <path d="M0 -500C100 -250 355 -100 355 185A150 150 0 0 1 55 185A10 10 0 0 0 35 185C35 385 85 400 130 500L-130 500C-85 400 -35 385 -35 185A10 10 0 0 0 -55 185A150 150 0 0 1 -355 185C-355 -100 -100 -250 0 -500Z" fill="black"/>
   </symbol>
   <rect width="239" height="335" x="-119.5" y="-167.5" rx="12" ry="12" fill="white" stroke="black"/>
   <use xlink:href="#S" height="70" width="70" x="-87.501" y="-35"/>
   <use xlink:href="#S" height="70" width="70" x="17.501" y="-35"/>
   <use xlink:href="#S" height="70" width="70" x="-35" y="-85.25"/>
   <use xlink:href="#S7" height="32" width="32" x="-114.4" y="-156"/>
   <use xlink:href="#S" height="26.769" width="26.769" x="-111.784" y="-119"/>
   <use xlink:href="#S" height="70" width="70" x="-87.501" y="-135.501"/>
   <use xlink:href="#S" height="70" width="70" x="17.501" y="-135.501"/>
   <g transform="rotate(180)">
      <use xlink:href="#S7" height="32" width="32" x="-114.4" y="-156"/>
      <use xlink:href="#S" height="26.769" width="26.769" x="-111.784" y="-119"/>
      <use xlink:href="#S" height="70" width="70" x="-87.501" y="-135.501"/>
      <use xlink:href="#S" height="70" width="70" x="17.501" y="-135.501"/>
   </g>
</svg>
